/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type b2b_v1_portfolio_builder_portfolio_proposal_CreateExternalPosition = {
    amount: number;
    /**
     * Ticker for the security. For cash positions use CASH.SEK.
     */
    correlation_proxy?: string | null;
    currency: string;
    expected_return?: number | null;
    name: string;
    type: b2b_v1_portfolio_builder_portfolio_proposal_CreateExternalPosition.type;
    volatility?: number | null;
};
export namespace b2b_v1_portfolio_builder_portfolio_proposal_CreateExternalPosition {
    export enum type {
        STOCK = 'stock',
        REAL_ESTATE = 'real_estate',
        CRYPTO = 'crypto',
        SAVINGS_ACCOUNT = 'savings_account',
        OTHER = 'other',
    }
}

